import React from 'react';
import Switch from 'components/DesignSystem/Switch';
import TooltipWrapper from 'components/DesignSystem/TooltipWrapper';
import IconActionButton from 'components/IconActionButton';
import { WindxPainelOption } from 'types/Windx/Models/windxPainelOption';
import { categoriaLabel, telasLabel } from 'helper/Windx/modelLabels';

export interface ModelsRowProps {
  model: WindxPainelOption;
  isPending: boolean;
  onEdit: (model: WindxPainelOption) => void;
  onToggleAtivo: (model: WindxPainelOption) => void;
  onDelete: (model: WindxPainelOption) => void;
}

export default function ModelsRow({
  model, isPending, onEdit, onToggleAtivo, onDelete,
}: ModelsRowProps) {
  return (
    <tr data-testid={`windx-modelo-row-${model.id}`}>
      <td>{model.id}</td>
      <td>{model.codigo}</td>
      <td>{model.config.label}</td>
      <td className="small">{telasLabel(model.telas)}</td>
      <td className="small">{categoriaLabel(model.categoria)}</td>
      <td>{model.order_by}</td>
      <td>
        <TooltipWrapper title={model.ativo ? 'Ocultar do painel' : 'Exibir no painel'}>
          <Switch
            checked={model.ativo}
            disabled={isPending}
            onChange={() => onToggleAtivo(model)}
            aria-label={`Visibilidade do modelo ${model.codigo}`}
            data-testid={`windx-modelo-switch-${model.id}`}
          />
        </TooltipWrapper>
      </td>
      <td>
        <div className="d-flex gap-2">
          <IconActionButton
            icon="edit"
            variant="primary"
            label="Editar modelo"
            disabled={isPending}
            onClick={() => onEdit(model)}
            id={`edit-windx-modelo-${model.id}`}
          />
          <IconActionButton
            icon="trash"
            variant="danger"
            label="Excluir modelo"
            disabled={isPending}
            onClick={() => onDelete(model)}
            id={`delete-windx-modelo-${model.id}`}
          />
        </div>
      </td>
    </tr>
  );
}
